import microsoftPartnerBadge from "@/assets/microsoft-partner-badge.png";
import hubspotLogo from "@/assets/logo-hubspot.svg";
import dynamics365Logo from "@/assets/logo-dynamics365-new.png";
import { companyInfo, getYearsInBusiness } from "@/lib/companyInfo";

const TrustStats = () => {
  return (
    <section className="relative overflow-hidden bg-background py-16 lg:py-20">
      <div className="cosmic-glow absolute -bottom-40 left-1/2 -translate-x-1/2 pointer-events-none" aria-hidden="true" />
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl rounded-2xl border border-cosmic-strong bg-card/60 p-8 backdrop-blur-md shadow-medium">
          <p className="text-center text-muted-foreground text-sm mb-6">
            Trusted by businesses across industries
          </p>
          <div className="flex items-center justify-center gap-4 lg:gap-6 flex-wrap">
            <div className="text-center">
              <div className="text-2xl font-bold text-foreground">{getYearsInBusiness()}</div>
              <div className="text-xs text-muted-foreground">Years in Business</div>
            </div>
            <div className="hidden sm:block w-px h-10 bg-cosmic-strong" />
            <div className="text-center">
              <div className="text-2xl font-bold text-foreground">200+</div>
              <div className="text-xs text-muted-foreground">Clients</div>
            </div>
            <div className="hidden sm:block w-px h-10 bg-cosmic-strong" />
            <div className="text-center">
              <div className="text-2xl font-bold text-foreground">Hundreds</div>
              <div className="text-xs text-muted-foreground">of Migrations</div>
            </div>
            <div className="hidden sm:block w-px h-10 bg-cosmic-strong" />
            <div className="text-center">
              <div className="text-2xl font-bold text-foreground">{companyInfo.stats.combinedExperience}</div>
              <div className="text-xs text-muted-foreground">{companyInfo.stats.combinedExperienceLabel}</div>
            </div>
            <div className="hidden sm:block w-px h-10 bg-cosmic-strong" />
            <div className="text-center">
              <div className="text-lg font-bold text-foreground">Enterprise to SMB</div>
              <div className="text-xs text-muted-foreground">Clients of All Sizes</div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-cosmic">
            <div className="flex items-center justify-center gap-8 lg:gap-12 flex-wrap">
              <img
                src={microsoftPartnerBadge}
                alt="Microsoft Solutions Partner for Modern Work and Business Applications"
                className="w-[200px] h-auto object-contain brightness-0 invert opacity-80 hover:opacity-100 transition-opacity"
                width="120"
                height="64"
                loading="lazy"
                decoding="async"
              />
              <img
                src={hubspotLogo}
                alt="HubSpot Partner"
                className="h-14 lg:h-16 w-auto object-contain brightness-0 invert opacity-80 hover:opacity-100 transition-opacity"
                width="104"
                height="56"
                loading="lazy"
                decoding="async"
              />
              <img
                src={dynamics365Logo}
                alt="Microsoft Dynamics 365"
                className="h-12 lg:h-14 w-auto object-contain brightness-0 invert opacity-80 hover:opacity-100 transition-opacity"
                width="149"
                height="84"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustStats;
